import { SelectInput, SelectInputItem } from '@ads/components-react';

/** Opção de filtro de módulo (com contagem de itens). */
export interface ModuleFilterOption {
  readonly id: string;
  readonly label: string;
  readonly count: number;
}

export interface ModuleFilterSelectProps {
  readonly label: string;
  readonly filters: readonly ModuleFilterOption[];
  readonly active: string;
  readonly onSelect: (id: string) => void;
}

/**
 * Filtro por módulo usando `SelectInput` do ADS, com a contagem de itens embutida em
 * cada opção. O valor selecionado reflete o módulo ativo.
 */
export function ModuleFilterSelect({ label, filters, active, onSelect }: ModuleFilterSelectProps) {
  return (
    <SelectInput
      className="flex !flex-row items-center !gap-nano !w-full"
      label={label}
      value={active}
      onValueChange={onSelect}
    >
      {filters.map(f => (
        <SelectInputItem key={f.id} value={f.id} custom={{ root: 'text-nowrap' }}>
          {`${f.label} (${f.count})`}
        </SelectInputItem>
      ))}
    </SelectInput>
  );
}
